module.exports = __webpack_public_path__ + "img/рз_53.5f981906.png";